import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/images/skill-assessment/icons/info.svg'


const _hoisted_1 = { class: "column is-full-mobile is-half-desktop p-3 mb-4" }
const _hoisted_2 = { class: "mb-4" }
const _hoisted_3 = { class: "passing-info has-text-primary is-radius-4 p-3" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[1] || (_cache[1] = _createElementVNode("div", { class: "medium-text mb-4" }, "About This Assessment", -1)),
    _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.quizDescription), 1),
    _createElementVNode("div", _hoisted_3, [
      _cache[0] || (_cache[0] = _createElementVNode("div", { class: "bold-text" }, [
        _createElementVNode("img", {
          src: _imports_0,
          style: {"height":"16px"},
          class: "mr-1"
        }),
        _createTextVNode(" Passing Score Required ")
      ], -1)),
      _createElementVNode("div", null, " You need to score " + _toDisplayString(_ctx.quizPassingScore) + "% or higher to pass this assessment. Take your time and read each question carefully. ", 1)
    ])
  ]))
}